import { css } from '@emotion/react';
import { styled } from '@mui/material';

import { Spinner } from '../Spinner';

import type { SpinnerProps } from '../Spinner';

export interface ModalBodyLoadingProps extends Pick<SpinnerProps, 'size'> {}

export default function ModalBodyLoading(props: ModalBodyLoadingProps) {
  const { size = 'lg' } = props;

  return (
    <ModalBodyLoadingRoot>
      <ModalBodyLoadingSpinner size={size} />
    </ModalBodyLoadingRoot>
  );
}

const ModalBodyLoadingRoot = styled('div')(
  ({ theme }) => css`
    margin-top: 0;

    position: absolute;
    inset: 0;
    background-color: rgba(255, 255, 255, 0.7);
    z-index: ${theme.zIndex.localLoader};
  `,
);

const ModalBodyLoadingSpinner = styled(Spinner)(
  ({ theme }) => css`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: ${theme.zIndex.localLoaderContent};
  `,
);
